import React from "react"
import Annotation from "./annotation"

export function annotationTransformer(node, i, { classList, children }) {
  if (classList.includes("wp-block-dekoder-custom-blocks-annotation")) {
    const { id } = node.attribs
    return <Annotation {...{ id, children }} />
  }
}
